export default __webpack_public_path__ + "static/media/BookQuest2.94814c86.jpg";